<!-- futures-trade-history.component.html -->
<div class="mat-caption" style="margin-bottom:8px;">
  futures trades: {{ futuresHistory.rows?.length || 0 }}
</div>

<table mat-table [dataSource]="futuresHistory.rows">
  <!-- Reuse the same columns as spot; adjust names if your template differs -->
  <ng-container matColumnDef="block">
    <th mat-header-cell *matHeaderCellDef>Block</th>
    <td mat-cell *matCellDef="let r">{{ r.block }}</td>
  </ng-container>

  <ng-container matColumnDef="side">
    <th mat-header-cell *matHeaderCellDef>Side</th>
    <td mat-cell *matCellDef="let r">{{ r.side }}</td>
  </ng-container>

  <ng-container matColumnDef="amount">
    <th mat-header-cell *matHeaderCellDef>Amount</th>
    <td mat-cell *matCellDef="let r">{{ r.baseAmount | number:'1.0-8' }}</td>
  </ng-container>

  <ng-container matColumnDef="price">
    <th mat-header-cell *matHeaderCellDef>Price</th>
    <td mat-cell *matCellDef="let r">{{ r.price | number:'1.0-8' }}</td>
  </ng-container>

  <ng-container matColumnDef="total">
    <th mat-header-cell *matHeaderCellDef>Total</th>
    <td mat-cell *matCellDef="let r">{{ r.totalQuote | number:'1.0-8' }}</td>
  </ng-container>

  <ng-container matColumnDef="role">
    <th mat-header-cell *matHeaderCellDef>Your Role</th>
    <td mat-cell *matCellDef="let r">{{ r.yourRole }}</td>
  </ng-container>

  <ng-container matColumnDef="fee">
    <th mat-header-cell *matHeaderCellDef>Fee</th>
    <td mat-cell *matCellDef="let r">{{ r.yourFee ?? '-' }}</td>
  </ng-container>

  <ng-container matColumnDef="tx">
    <th mat-header-cell *matHeaderCellDef>Tx</th>
    <td mat-cell *matCellDef="let r">
      <a *ngIf="txUrl(r) as url" [href]="url" target="_blank" rel="noopener">{{ shortTx(r.txid || '') }}</a>
      <span *ngIf="!txUrl(r)">{{ shortTx(r.txid || '') }}</span>
    </td>
  </ng-container>

  <ng-container matColumnDef="counterparty">
    <th mat-header-cell *matHeaderCellDef>Counterparty</th>
    <td mat-cell *matCellDef="let r">
      <span (click)="copy(r.side === 'BUY' ? r.seller : r.buyer)">
        {{ (r.side === 'BUY' ? r.seller : r.buyer) | slice:0:6 }}…{{ (r.side === 'BUY' ? r.seller : r.buyer) | slice:-6 }}
      </span>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>